import dynamic from 'next/dynamic';

import { hasFinancingSection } from '@/utils/propertyDataUtils';
import { useShouldHideUserAccountExclusiveContent } from '@/hooks/useShouldHideUserAccountExclusiveContent';
import { useListing } from '@/hooks/queries/useListing';

const FinancingSection = dynamic(
  () => import('@/components/property-expose/FinancingSection/FinancingSection').then((mod) => mod.FinancingSection),
  {
    ssr: false,
  },
);

export const DynamicFinancingSection = () => {
  const isUAExclusiveListingAndNotSignedIn = useShouldHideUserAccountExclusiveContent();
  const {
    data: { listing },
  } = useListing();

  if (!listing || !hasFinancingSection(listing) || isUAExclusiveListingAndNotSignedIn) return null;

  return <FinancingSection listing={listing} />;
};
